import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

import {Icon} from "./Icon";
import NavIcons from "../util/NavIcons";
import * as styles from "./styles/NavButtonIcon.module.css";

type NavButtonProps = {
	iconName: string;
	className?: string;
};

function NavButtonIcon({iconName, className}: NavButtonProps) {
	const NavIcon = NavIcons[iconName];
	const iconClasses = clsx(styles?.icon, className);

	if (NavIcon) {
		return <NavIcon className={iconClasses} />;
	}

	return <Icon iconName={iconName} className={iconClasses} />;
}

NavButtonIcon.propTypes = {
	iconName: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default NavButtonIcon;
